import { useContext, useEffect } from "react";
import { AppTitleContext } from "app_context";

export default function useDumbPageTitle(title) {
  const appTitleContext = useContext(AppTitleContext);

  useEffect(() => {
    appTitleContext.setPageTitle(title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
